import { Component, Inject } from '@angular/core';
import {
  NotificationService,
  Notification,
} from '@shared/services/notification/notification.service';

import { TechIconModule } from '@tech/components/tech-icon';

@Component({
  selector: 'app-notifications',
  standalone: true,
  imports: [TechIconModule],
  templateUrl: './notification-service.component.html',
  styleUrl: './notification-service.component.scss',
})
export class NotificationServiceComponent {
  notifications: Notification[] = [];

  constructor(private notificationService: NotificationService) {
    this.notificationService.notification$.subscribe(
      (ns: Notification[]) => (this.notifications = ns)
    );
  }
  dismiss(id: number) {
    this.notificationService.dismiss(id);
  }
}
